import { en, nbNO, de } from 'vuejs-datepicker/dist/locale';
import { Language } from '../enums/Language';
import { Locale } from '../enums/Locale';

export default class I18nOperations {
  /**
   * Get navigator matched locale. Return EN_GB when no supported language is available.
   *
   * @param browserLocales
   * @return {string} locale
   */
  static getNavigatorMatchedLocale(browserLocales) {
    let returnLocale = Locale.EN_GB;
    browserLocales.some(bl => {
      if (bl.startsWith('en')) {
        returnLocale = Locale.EN_GB;
        return true;
      } else if (bl.startsWith('nb') || bl.startsWith('no')) {
        returnLocale = Locale.NB_NO;
        return true;
      } else if (bl.startsWith('de')) {
        returnLocale = Locale.DE_DE;
        return true;
      }
    });
    return returnLocale;
  }

  static getAvailableLocalesAsSelectionList() {
    return [
      {
        name: Language.English,
        value: Locale.EN_GB,
      },
      {
        name: Language.Norwegian,
        value: Locale.NB_NO,
      },
      {
        name: Language.German,
        value: Locale.DE_DE,
      },
    ];
  }

  static getAvailableNativeLocalesAsSelectionList() {
    return [
      {
        name: 'English',
        value: Locale.EN_GB,
      },
      {
        name: 'Norsk',
        value: Locale.NB_NO,
      },
      {
        name: 'Deutsch',
        value: Locale.DE_DE,
      },
    ];
  }

  static getLanguageOfLocale(locale) {
    switch (locale) {
      case Locale.EN_GB:
      case Locale.EN:
        return Language.English;
      case Locale.NB_NO:
      case Locale.NO:
        return Language.Norwegian;
      case Locale.DE_DE:
        return Language.German;
    }
  }

  static getNativeLanguageOfLocale(locale) {
    switch (locale) {
      case Locale.EN_GB:
      case Locale.EN:
        return 'English';
      case Locale.NB_NO:
      case Locale.NO:
        return 'Norsk';
      case Locale.DE_DE:
        return 'Deutsch';
    }
  }

  static getLanguageCodeForLocale(locale) {
    return locale ? locale.substring(0, 2) : '';
  }

  static getDateLabelFormat(locale) {
    switch (locale) {
      case Locale.EN_GB:
      case Locale.EN:
        return 'dd.mm.yyyy';
      case Locale.NB_NO:
      case Locale.NO:
        return 'dd.mm.åååå';
      case Locale.DE_DE:
      case Locale.DE:
        return 'tt.mm.jjjj';
    }
  }

  static getDMLabelFormat(locale) {
    if (locale === Locale.DE_DE || locale === Locale.DE) {
      return 'tt.mm.';
    }
    return 'dd.mm.';
  }

  static getDatePickerTranslations(locale) {
    switch (locale) {
      case Locale.EN_GB:
      case Locale.EN:
        return en;
      case Locale.NB_NO:
      case Locale.NO:
        return nbNO;
      case Locale.DE_DE:
        return de;
    }
  }

  static getIETFLocale(locale) {
    switch (locale) {
      case Locale.EN_GB:
      case Locale.EN:
        return 'en-gb';
      case Locale.NB_NO:
      case Locale.NO:
        return 'nb';
      case Locale.DE_DE:
        return 'de';
    }
  }

  static toCurrency(locale, currency, value) {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    });
    return formatter.format(value ? value : 0);
  }
}
